if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        this.mainItems = this.querySelectorAll('.product__media-item');

        this.touchStartX = 0;
        this.touchEndX = 0;
        this.minSwipeDistance = 50;

        // Bind touch handlers
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.slideProgress = this.querySelector('.ImageGallery-progress');
      }

      connectedCallback() {
        if (window.innerWidth < 1024) {
          this.attachTouchEvents();
          this.nextBtn = this.querySelector('.js-smp-bundle-gallery-arrow-right');
          this.prevBtn = this.querySelector('.js-smp-bundle-gallery-arrow-left');
          this.nextBtn.addEventListener('click', this.changeMedia.bind(this, 'next'));
          this.prevBtn.addEventListener('click', this.changeMedia.bind(this, 'prev'));
        }
      }

      attachTouchEvents() {
        this.querySelector('.product__media-list ').addEventListener('touchstart', this.onTouchStart);
        this.querySelector('.product__media-list ').addEventListener('touchend', this.onTouchEnd);
      }

      onSlideChanged(event) {
        if (!event?.detail?.currentElement) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');
        activeMedia.style.opacity = 1;

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail &&
                activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        if (!prepend) {
          this.preventStickyHeader();
          window.setTimeout(() => {
            if (!this.mql.matches || this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
            }
            const activeMediaRect = activeMedia.getBoundingClientRect();
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
        }
        this.playActiveMedia(activeMedia);

        // Update progress after setting active media
        this.updateSlideProgress();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      onTouchStart(event) {
        this.touchStartX = event.touches[0].clientX;
      }

      onTouchEnd(event) {
        this.touchEndX = event.changedTouches[0].clientX;
        this.handleSwipe();
        this.touchStartX = 0;
        this.touchEndX = 0;
      }

      handleSwipe() {
        const swipeDistance = this.touchEndX - this.touchStartX;
        if (Math.abs(swipeDistance) < this.minSwipeDistance) return;

        const activeMedia = this.elements.viewer.querySelector('[data-media-id].is-active');
        const totalSlides = this.elements.viewer.sliderItems.length;
        let currentIndex = Array.from(this.elements.viewer.sliderItems).indexOf(activeMedia);

        if (swipeDistance > 0) {
          currentIndex = currentIndex === 0 ? totalSlides - 1 : currentIndex - 1;
          this.changeMedia('prev');
        } else {
          currentIndex = currentIndex === totalSlides - 1 ? 0 : currentIndex + 1;
          this.changeMedia('next');
        }
      }

      updateSlideProgress() {
        if (!this.slideProgress) return;

        const activeMedia = this.elements.viewer.querySelector('[data-media-id].is-active');
        if (!activeMedia) return;

        const totalSlides = this.elements.viewer.sliderItems.length;
        const currentIndex = Array.from(this.elements.viewer.sliderItems).indexOf(activeMedia);

        this.slideProgress.textContent = `${currentIndex + 1} / ${totalSlides}`;
      }

      changeMedia(direction) {
        const activeMedia = this.elements.viewer.querySelector('[data-media-id].is-active');
        if (!activeMedia) return;

        activeMedia.style.opacity = 0;

        if (direction === 'next') {
          if (activeMedia.nextElementSibling) {
            this.setActiveMedia(activeMedia.nextElementSibling.dataset.mediaId, false);
          } else {
            this.setActiveMedia(this.elements.viewer.sliderItems[0].dataset.mediaId, false);
          }
        } else {
          if (activeMedia.previousElementSibling) {
            this.setActiveMedia(activeMedia.previousElementSibling.dataset.mediaId, false);
          } else {
            this.setActiveMedia(
              this.elements.viewer.sliderItems[this.elements.viewer.sliderItems.length - 1].dataset.mediaId,
              false,
            );
          }
        }

        // Update progress after changing media
        this.updateSlideProgress();
      }
    },
  );
}
